document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.wp-why-slider__track');
    
    if (!slider) return;

    const firstCard = slider.querySelector('.wp-why-card');
    if (!firstCard) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let animationId = null;
    let speed = 1.0; // Auto-scroll speed
    let isMouseOver = false;

    // Measurement logic
    let cardWidthWithGap = firstCard.offsetWidth + 25; // 25px gap
    let totalCards = slider.querySelectorAll('.wp-why-card').length / 3;
    let middleOffset = cardWidthWithGap * totalCards;
    
    // Re-measure on window resize
    const updateMeasurements = () => {
        cardWidthWithGap = firstCard.offsetWidth + 25;
        middleOffset = cardWidthWithGap * totalCards;
    };

    window.addEventListener('resize', updateMeasurements);
    
    // Important: Initialize scroll position
    requestAnimationFrame(() => {
        updateMeasurements();
        slider.scrollLeft = middleOffset;
    });

    const startAutoScroll = () => {
        if (!isDown && !isMouseOver) {
            slider.scrollLeft += speed;
            
            // Loop back seamlessly
            if (slider.scrollLeft >= middleOffset * 2) {
                slider.scrollLeft = middleOffset;
            } else if (slider.scrollLeft <= 0) {
                slider.scrollLeft = middleOffset;
            }
        }
        animationId = requestAnimationFrame(startAutoScroll);
    };

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('is-dragging');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        isMouseOver = false;
        slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mouseenter', () => {
        isMouseOver = true;
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    });

    // Handle touch events
    slider.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    }, { passive: true });

    slider.addEventListener('touchend', () => {
        isDown = false;
    });

    slider.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        const x = e.touches[0].pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    }, { passive: false });

    // Arrow navigation buttons
    const sliderEl = slider.parentElement;
    const prevBtn = sliderEl && sliderEl.querySelector('.slider-arrow--prev');
    const nextBtn = sliderEl && sliderEl.querySelector('.slider-arrow--next');
    if (prevBtn && nextBtn) {
        const pause = () => {
            isMouseOver = true;
            setTimeout(() => { isMouseOver = false; }, 700);
        };
        prevBtn.addEventListener('click', () => {
            pause();
            slider.scrollBy({ left: -cardWidthWithGap, behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', () => {
            pause();
            slider.scrollBy({ left: cardWidthWithGap, behavior: 'smooth' });
        });
    }

    // Start the animation
    startAutoScroll();
});
